import React, { useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import { useParams } from "react-router-dom";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import CipHeader from "../Components/CipHeader";
import cogoToast from "cogo-toast";
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";
import Loader from "react-loader-spinner";
import eomUnitcostService from "../services/eom-unitcost-service";

const EditUnitCost = ({ history }) => {
  const { id } = useParams();

  const { register, handleSubmit, errors } = useForm({});

  useEffect(() => {
    if (id) getUnitCostDetails(id);
  }, [id]);
  const [details, setdetails] = useState();
  const [formattedUnitCostList, setFormattedUnitCostList] = useState();
  const [loading, setLoading] = useState(false);

  const getUnitCostDetails = async (id) => {
    try {
      setLoading(true);
      const resp = await eomUnitcostService.getData(id);
      setdetails(resp);
      formatUnitCost(resp);
      setLoading(false);
    } catch (e) {
      const { hide } = cogoToast.error(
        "Error while fetching Unit Price details. Please try after sometime.",
        {
          hideAfter: 15,
          onClick: () => {
            hide();
          },
        }
      );
      setLoading(false);
    }
  };
  const onSubmit = async (data) => {
    try {
      setLoading(true);
      let params = {};
      for (const [key, value] of Object.entries(data)) {
        if (key.startsWith("flag")) {
          if (value) {
            params[key] = "T";
          } else {
            params[key] = "F";
          }
        } else {
          if (key === "other_amt") {
            params[key] = value !== "" ? Number(value) : 0;
          }
        }
      }

      if (id) {
        params["id"] = id;
        await eomUnitcostService.updateData(params);
      }
      await history.push("/unitcost");

      setLoading(false);
    } catch (e) {
      const { hide } = cogoToast.error(
        "Error submitting drug details. Please try after sometime.",
        {
          hideAfter: 15,
          onClick: () => {
            hide();
          },
        }
      );
      setLoading(false);
    }
  };

  const formatUnitCost = (data) => {
    let list = [];
    if (Object.keys(data).length) {
      for (const [key, value] of Object.entries(data)) {
        if (key.startsWith("price")) {
          if (!value || value === 0) {
            break;
          }
          list.push({
            flag: {
              key: "flag_" + key.split("_")[1],
              value: data["flag_" + key.split("_")[1]],
            },
            cost: {
              key: "price_" + key.split("_")[1],
              value,
              display: "Price " + key.split("_")[1],
            },
          });
        }
      }
    }
    setFormattedUnitCostList(list);
  };

  return (
    <>
      <div
        className={`inline-block customtop absolute z-50 ${
          loading ? "show" : "hidden"
        }`}
      >
        <Loader
          type="Oval"
          color="#00B2A9"
          height={50}
          width={50}
          timeout={300000} //3 secs
        />
      </div>
      <CipHeader />
      <div className="bg-white w-1/2 mx-auto mt-6 mb-4 rounded shadow-md">
        <div className="tableHeader flex clearboth shadow-md py-8 pl-3 w-full">
          <div className="w-full text-darkclr font-semibold leading-10 ">
            <span className="text-xl">{id ? "EDIT" : "CREATE"}</span>
          </div>
        </div>
        <div className="px-12 py-5">
          <form onSubmit={handleSubmit(onSubmit)}>
            <ul className="text-left">
              <li className="inline-block text-xs leading-6 text-menu_txt w-full mb-3">
                <label className="text-labelclr font-semibold text-sm tracking-wider">
                  Drug name
                </label>

                <input
                  id="drug_name"
                  name="drug_name"
                  disabled={true}
                  type="text"
                  placeholder="Drug name"
                  ref={register({
                    required: false,
                  })}
                  defaultValue={details?.drug_name || ""}
                  className={` ${
                    errors.drug_name ? "border-red-400" : ""
                  } border focus:outline-none h-11 rounded-md pl-2 font-normal w-full text-fogotpwsd_login text-sm`}
                />

                {errors.drug_name && (
                  <p className="text-xs md:text-sm md:pt-1 text-hlred">
                    {errors.drug_name?.message}
                  </p>
                )}
              </li>

              <li className="inline-block text-xs leading-6 text-menu_txt w-full mb-3">
                <label className="text-labelclr font-semibold text-sm tracking-wider">
                  NDC
                </label>

                <input
                  id="ndc"
                  name="ndc"
                  type="text"
                  disabled={true}
                  placeholder="NDC"
                  ref={register({
                    required: false,
                  })}
                  defaultValue={details?.ndc || ""}
                  className={` ${
                    errors.ndc ? "border-red-400" : ""
                  } border focus:outline-none h-11 rounded-md pl-2 font-normal w-full text-fogotpwsd_login text-sm`}
                />

                {errors.ndc && (
                  <p className="text-xs md:text-sm md:pt-1 text-hlred">
                    {errors.ndc?.message}
                  </p>
                )}
              </li>

              <li className="inline-block text-xs leading-6 text-menu_txt w-full mb-3">
                <label className="text-labelclr font-semibold text-sm tracking-wider">
                  Old Name
                </label>

                <input
                  id="old_name"
                  name="old_name"
                  type="text"
                  disabled={true}
                  placeholder="Old Name"
                  ref={register({
                    required: false,
                  })}
                  defaultValue={details?.old_name || ""}
                  className={` ${
                    errors.old_name ? "border-red-400" : ""
                  } border focus:outline-none h-11 rounded-md pl-2 font-normal w-full text-fogotpwsd_login text-sm`}
                />

                {errors.old_name && (
                  <p className="text-xs md:text-sm md:pt-1 text-hlred">
                    {errors.old_name?.message}
                  </p>
                )}
              </li>

              <li className="inline-block text-xs leading-6 text-menu_txt w-full mb-3">
                <label className="text-labelclr font-semibold text-sm tracking-wider">
                  Old Price
                </label>

                <input
                  id="old_price"
                  name="old_price"
                  type="number"
                  disabled={true}
                  placeholder="Old Price"
                  ref={register({
                    required: false,
                  })}
                  defaultValue={details?.old_price || ""}
                  className={` ${
                    errors.old_price ? "border-red-400" : ""
                  } border focus:outline-none h-11 rounded-md pl-2 font-normal w-full text-fogotpwsd_login text-sm`}
                />

                {errors.old_price && (
                  <p className="text-xs md:text-sm md:pt-1 text-hlred">
                    {errors.old_price?.message}
                  </p>
                )}
              </li>

              <li className="inline-block text-xs leading-6 text-menu_txt w-full mb-3">
                <label className="text-labelclr font-semibold text-sm tracking-wider">
                  Old Formula
                </label>

                <input
                  id="old_formula"
                  name="old_formula"
                  type="text"
                  disabled={true}
                  placeholder="Old Formula"
                  ref={register({
                    required: false,
                  })}
                  defaultValue={details?.old_formula || ""}
                  className={` ${
                    errors.old_formula ? "border-red-400" : ""
                  } border focus:outline-none h-11 rounded-md pl-2 font-normal w-full text-fogotpwsd_login text-sm`}
                />

                {errors.old_formula && (
                  <p className="text-xs md:text-sm md:pt-1 text-hlred">
                    {errors.old_formula?.message}
                  </p>
                )}
              </li>
              <li className="inline-block text-xs leading-6 text-menu_txt w-full mb-3">
                <label className="text-labelclr font-semibold text-sm tracking-wider">
                  New Name
                </label>

                <input
                  id="new_name"
                  name="new_name"
                  type="text"
                  disabled={true}
                  placeholder="New Name"
                  ref={register({
                    required: false,
                  })}
                  defaultValue={details?.new_name || ""}
                  className={` ${
                    errors.new_name ? "border-red-400" : ""
                  } border focus:outline-none h-11 rounded-md pl-2 font-normal w-full text-fogotpwsd_login text-sm`}
                />

                {errors.new_name && (
                  <p className="text-xs md:text-sm md:pt-1 text-hlred">
                    {errors.new_name?.message}
                  </p>
                )}
              </li>

              <li className="inline-block text-xs leading-6 text-menu_txt w-full mb-3">
                {formattedUnitCostList
                  ? formattedUnitCostList.map((item, i) => {
                      return (
                        <div key={i}>
                          <label className="text-labelclr font-semibold text-sm tracking-wider">
                            {item.cost.display}
                          </label>
                          <div className="flex flex-row items-center mb-2 text-base	">
                            <span className="pl-2">
                              <input
                                type="checkbox"
                                id={item.flag.key}
                                name={item.flag.key}
                                value={item.flag.value}
                                defaultChecked={
                                  item.flag.value === "T" ? true : false
                                }
                                ref={register({
                                  required: false,
                                })}
                              />
                              <label> {item.cost.value}</label>
                            </span>
                          </div>
                        </div>
                      );
                    })
                  : null}
              </li>

              <li className="inline-block text-xs leading-6 text-menu_txt w-full mb-3">
                <label className="text-labelclr font-semibold text-sm tracking-wider">
                  Other Amount
                </label>

                <input
                  id="other_amt"
                  name="other_amt"
                  type="number"
                  placeholder="Other Amount"
                  step={".01"}
                  min={0}
                  ref={register({
                    required: false,
                  })}
                  defaultValue={details?.other_amt || ""}
                  className={` ${
                    errors.other_amt ? "border-red-400" : ""
                  } border focus:outline-none h-11 rounded-md pl-2 font-normal w-full text-fogotpwsd_login text-sm`}
                />

                {errors.other_amt && (
                  <p className="text-xs md:text-sm md:pt-1 text-hlred">
                    {errors.other_amt?.message}
                  </p>
                )}
              </li>

              <li className="inline-block text-sm leading-8 w-full">
                <button
                  type="submit"
                  className="rounded font-medium h-10 text-white w-full bg-login_btn my-3 focus:outline-none text-sm"
                  aria-label="Create user"
                >
                  SUBMIT
                </button>
              </li>
            </ul>
          </form>
        </div>
      </div>
    </>
  );
};

export default withRouter(
  connect(
    () => ({}),
    (dispatch) => {
      return bindActionCreators({}, dispatch);
    }
  )(EditUnitCost)
);
